import { Dialog, Slide } from '@material-ui/core';
import React from 'react';
import EditVersionContent from './EditVersionContent';
import useStyles from './styles';

export { EditVersionContent };

// Modal trượt từ dưới lên khi mở
const SlideUpTransition = React.forwardRef(function SlideUpTransition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function EditVersionModal({
  open,
  onClose,
  device,
  fetchDetail,
  onLive4gChanged,
  onCameraConfigApplied
}) {
  const classes = useStyles();

  return (
    <Dialog
      disableBackdropClick
      fullWidth
      maxWidth="md"
      open={open}
      onClose={onClose}
      TransitionComponent={SlideUpTransition}
      classes={{ paper: classes.dialogPaper }}
      BackdropProps={{ className: classes.dialogBackdrop }}
    >
      <EditVersionContent
        title="Cấu hình thiết bị"
        device={device}
        fetchDetail={fetchDetail}
        onClose={onClose}
        onLive4gChanged={onLive4gChanged}
        onCameraConfigApplied={onCameraConfigApplied}
      />
    </Dialog>
  );
}

export default React.memo(EditVersionModal);
